import { render, staticRenderFns } from "./DetailHpp.vue?vue&type=template&id=50d1ad26"
import script from "./DetailHpp.vue?vue&type=script&lang=js"
export * from "./DetailHpp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports